var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBbTestBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UI:_Stamp",
    "data-name": "UI: Stamp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 63,
    cy: 63,
    r: 63,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(11.154 6.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462",
    transform: "translate(10.766 15.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1285.559,555.245h20.085a.681.681,0,0,0,.584-1.031,21.312,21.312,0,0,1-2.771-7.917.678.678,0,0,0-.674-.588H1284.1a.69.69,0,0,0-.682.7c0,.012,0,.025,0,.037a41.282,41.282,0,0,0,1.49,8.31A.676.676,0,0,0,1285.559,555.245Z",
    transform: "translate(-1283.415 -501.913)",
    fill: "#c8372f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M1284.195,510.565H1302.9a.68.68,0,0,0,.672-.573,21.318,21.318,0,0,1,2.942-7.917.682.682,0,0,0-.575-1.044h-20.208a.68.68,0,0,0-.651.484,41.38,41.38,0,0,0-1.567,8.308.681.681,0,0,0,.62.739Z",
    transform: "translate(-1283.48 -471.964)",
    fill: "#c8372f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M1332.588,412.868a41.221,41.221,0,0,0-24.137,7.9.68.68,0,0,0,.414,1.242h34.2a1.475,1.475,0,0,1,1.38,2l-.875,2.241a1.474,1.474,0,0,1-1.38.944h-40.424a.688.688,0,0,0-.519.239,41.507,41.507,0,0,0-5.5,8.314.681.681,0,0,0,.618.981h23.847a.692.692,0,0,0,.388-.122,21.447,21.447,0,1,1-.526,34.923.68.68,0,0,0-.414-.138h-23.494a.681.681,0,0,0-.618.974,41.419,41.419,0,0,0,5.382,8.316.68.68,0,0,0,.523.243h19.964a.68.68,0,0,1,.635.927l-1.29,3.331a1.475,1.475,0,0,1-1.38.944h-11.052a.68.68,0,0,0-.414,1.224,41.4,41.4,0,1,0,24.673-74.485Z",
    transform: "translate(-1291.502 -412.867)",
    fill: "#c8372f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(0 76.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M1250.761,604.044l6.266-3.257,1.524,2.931a3.1,3.1,0,0,1,.448,1.846,1.572,1.572,0,0,1-.915,1.173,1.6,1.6,0,0,1-1.738-.089,1.7,1.7,0,0,1-.987,1.729,1.817,1.817,0,0,1-1.695.078,3.318,3.318,0,0,1-1.419-1.559Zm2.8,1.9a1.1,1.1,0,0,0,.44.513.575.575,0,0,0,.528-.046.583.583,0,0,0,.354-.412,1.13,1.13,0,0,0-.171-.652l-.429-.825-1.15.6Zm2.434-1.321a.933.933,0,0,0,.361.426.586.586,0,0,0,.729-.378.934.934,0,0,0-.141-.54l-.406-.781-.948.493Z",
    transform: "translate(-1250.761 -599.723)",
    fill: "#c8372f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M1273.634,638.013l5.407-4.543,1.444,1.719-5.407,4.543Z",
    transform: "translate(-1266.093 -621.63)",
    fill: "#c8372f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M1296.419,659.435l4.339-5.572,1.771,1.379-3.154,4.05,2.333,1.817-1.333,1.406Z",
    transform: "translate(-1281.366 -635.3)",
    fill: "#c8372f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M1330.41,680.265l2.866-6.454,3.019,1.341a3.1,3.1,0,0,1,1.5,1.164,1.572,1.572,0,0,1,.016,1.488,1.6,1.6,0,0,1-1.414,1.015,1.7,1.7,0,0,1,.306,1.967,1.817,1.817,0,0,1-1.276,1.118,3.319,3.319,0,0,1-2.081-.334Zm3.375-.265a1.106,1.106,0,0,0,.663.127.576.576,0,0,0,.384-.366.583.583,0,0,0,.019-.543,1.132,1.132,0,0,0-.541-.4l-.85-.377-.526,1.184Zm1.079-2.551a.932.932,0,0,0,.547.108.585.585,0,0,0,.333-.75.93.93,0,0,0-.447-.334l-.8-.357-.433.976Z",
    transform: "translate(-1304.15 -648.671)",
    fill: "#c8372f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M1375.374,695.145a3.448,3.448,0,0,1-2.427-1.349,3.758,3.758,0,0,1-.5-2.83,4.466,4.466,0,0,1,.718-1.91,2.929,2.929,0,0,1,1.406-1.087,3.949,3.949,0,0,1,2-.144,3.451,3.451,0,0,1,2.427,1.349,3.747,3.747,0,0,1,.5,2.82,3.83,3.83,0,0,1-1.359,2.586A3.494,3.494,0,0,1,1375.374,695.145Zm.326-1.9q1.222.19,1.5-1.569t-.948-1.95q-1.221-.19-1.5,1.569T1375.7,693.244Z",
    transform: "translate(-1332.283 -658.022)",
    fill: "#c8372f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M1416.739,696.868l-.68-7.029,2.235-.216.495,5.109,2.943-.285v1.938Z",
    transform: "translate(-1361.561 -659.27)",
    fill: "#c8372f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M1462.069,686.155l-.69-.958-2.1.772.105,1.173-2.079.765-.286-7.42,2.6-.957,4.574,5.841Zm-3.153-4.415.206,2.422,1.207-.444Z",
    transform: "translate(-1389.019 -652.505)",
    fill: "#c8372f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M1495.938,664.086l-.778.545-.982-1.4,2.47-1.731,1.93,2.754a4.52,4.52,0,0,1-.752,1.384,5.715,5.715,0,0,1-1.239,1.17,3.619,3.619,0,0,1-2.748.766,3.7,3.7,0,0,1-2.331-1.688,3.861,3.861,0,0,1-.818-2.8,3.937,3.937,0,0,1,3.677-3.018,2.6,2.6,0,0,1,1.823.878l-1.739,1.448a.927.927,0,0,0-.552-.271.94.94,0,0,0-.58.207,1.04,1.04,0,0,0-.517.882,2.525,2.525,0,0,0,.554,1.29,2.349,2.349,0,0,0,1.1.978,1.332,1.332,0,0,0,1.162-.289,2.182,2.182,0,0,0,.646-.646Z",
    transform: "translate(-1411.567 -639.459)",
    fill: "#c8372f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M1524.246,639.454l-5.367-4.59,3.413-3.991,1.316,1.125-1.98,2.315.684.585,1.851-2.165,1.316,1.125-1.851,2.165.737.63,2.108-2.465,1.206,1.253Z",
    transform: "translate(-1430.482 -619.89)",
    fill: "#c8372f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M1547.546,604.475l-4.6-2.285-.876,1.763-1.727-.858,2.751-5.536,1.727.858-.876,1.763,4.6,2.284Z",
    transform: "translate(-1444.872 -597.559)",
    fill: "#c8372f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(3.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M1267.043,440.617l-4.238-2.9-1.11,1.625-1.592-1.088,3.487-5.1,1.592,1.088-1.11,1.625,4.238,2.9Z",
    transform: "translate(-1260.102 -410.759)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M1292.233,412.456l-4.7-5.273,3.921-3.494,1.151,1.292-2.274,2.027.6.672,2.127-1.895,1.151,1.292-2.126,1.9.645.724,2.422-2.158,1.026,1.4Z",
    transform: "translate(-1278.491 -391.009)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M1325.705,387.717a3.646,3.646,0,0,1-1.935.153,1.817,1.817,0,0,1-1.155-.981,2.028,2.028,0,0,1-.09-1.879,3.58,3.58,0,0,1,1.689-1.571,3.5,3.5,0,0,1,2.139-.478,2.158,2.158,0,0,1,1.521,1.029l-1.845,1.189a.9.9,0,0,0-.492-.334.96.96,0,0,0-.59.141,1.1,1.1,0,0,0-.449.369.375.375,0,0,0-.015.387.338.338,0,0,0,.264.185,1.3,1.3,0,0,0,.521-.072l.933-.265a3.87,3.87,0,0,1,1.964-.152,1.819,1.819,0,0,1,1.144.992,2.114,2.114,0,0,1,.114,1.956,3.773,3.773,0,0,1-1.777,1.628,3.572,3.572,0,0,1-2.3.492,2.51,2.51,0,0,1-1.66-1.263l1.963-1.028a.885.885,0,0,0,.569.394,1.239,1.239,0,0,0,.762-.175q.71-.372.467-.836a.4.4,0,0,0-.278-.223,1.142,1.142,0,0,0-.521.06Z",
    transform: "translate(-1301.818 -377.097)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M1363.143,375.572l-1.174-5-1.916.45-.441-1.878,6.018-1.414.441,1.878-1.916.45,1.174,5Z",
    transform: "translate(-1326.804 -366.907)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M1403.42,372.334l-.3-1.143-2.235-.036-.325,1.132-2.215-.036,2.409-7.024,2.769.045,2.16,7.1Zm-1.349-5.255-.681,2.334,1.286.021Z",
    transform: "translate(-1352.769 -365.228)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M1440.209,375.882l1.9-6.8,2.791.781a3.845,3.845,0,0,1,2.409,1.594,3.419,3.419,0,0,1,.2,2.751,3.59,3.59,0,0,1-1.632,2.306,3.748,3.748,0,0,1-2.877.15Zm3.374-1.007a1.192,1.192,0,0,0,1.074-.131,2.012,2.012,0,0,0,.653-1.122,1.933,1.933,0,0,0,.02-1.263,1.234,1.234,0,0,0-.856-.666l-.753-.211-.891,3.181Z",
    transform: "translate(-1380.829 -367.811)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M1501.958,410.794l.494-1.073-1.705-1.445-.969.669-1.69-1.432,6.316-3.9,2.113,1.791-2.83,6.858Zm2.289-4.919-2.006,1.373.981.831Z",
    transform: "translate(-1419.625 -390.955)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M1529.287,434.563l4.491-5.85,1.409,1.959-3.122,3.671,4.473-1.792,1.386,1.927-6.986,2.381Z",
    transform: "translate(-1440.539 -407.782)",
    fill: "#888"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbTestBadge);
export default __webpack_public_path__ + "static/media/bb-test-badge.512afbe357909a49111ce4247ac7ac3e.svg";
export { ForwardRef as ReactComponent };